import { LanguageMenu } from "@/components/shared/LanguageMenu";
import { useChangeUserLanguage } from "@/features/settings/hooks/useSyncLanguageFromSettings";
import { useT } from "@/lib/translation";

/** App top bar language dropdown: switches and saves to the user's settings. */
export function UserLanguageMenu({
  withLabel = false,
}: {
  withLabel?: boolean;
}) {
  const t = useT();
  const changeLanguage = useChangeUserLanguage();
  const menu = (
    <LanguageMenu
      onSelect={changeLanguage}
      triggerClassName="h-10 rounded-lg border px-3"
    />
  );
  if (!withLabel) return menu;
  return (
    <div>
      <p className="text-sm font-medium mb-3 text-muted-foreground">
        {t("nav:layout.language")}
      </p>
      {menu}
    </div>
  );
}
